export default __webpack_public_path__ + "static/media/device-2021-04-29-122355_framed.751cbf98.png";